import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaFilePdf, FaDownload, FaExternalLinkAlt } from 'react-icons/fa';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PdfViewer from '../components/PdfViewer';
import { newsData } from '../data/newsData';
import './NewsDetail.css';

const NewsDetail = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    const found = newsData.find((item) => item.id === parseInt(id, 10));
    setArticle(found);
    window.scrollTo(0, 0);
  }, [id]);

  if (!article) return <div>Chargement...</div>;

  const pdfUrl = article.pdfUrl
    ? `${process.env.PUBLIC_URL || ''}${article.pdfUrl}`
    : null;

  return (
    <>
      <SEO
        title={`${article.title} | Actualités ATAA REALTY`}
        description={article.excerpt}
        canonical={`https://ataarealty.com/actualites/${article.id}`}
        ogType="article"
        ogImage={article.image}
        keywords="actualités immobilières Maroc, expertise immobilière, ATAA Realty"
      />
      <Navbar />

      {/* Header */}
      <div
        className="article-header"
        style={{ backgroundImage: `url(${article.image})` }}
      >
        <div className="article-overlay"></div>
        <div className="container header-text">
          <span className="article-meta">
            {article.date} {article.month} {article.year}
          </span>
          <h1>{article.title}</h1>
        </div>
      </div>

      <div className="container article-container">
        <div className="article-content">
          <div className="main-text">
            {article.content.split('\n\n').map((paragraph, i) => (
              <p key={i} className={i === 0 ? 'lead' : ''}>
                {paragraph}
              </p>
            ))}
          </div>

          {/* PDF section — only when this article has an attached document */}
          {pdfUrl && (
            <section className="article-pdf-section">
              <div className="article-pdf-header">
                <div className="article-pdf-title">
                  <FaFilePdf />
                  <div>
                    <span className="pdf-eyebrow">Document associé</span>
                    <h3>
                      {article.pdfTitle || 'Document PDF'}
                    </h3>
                  </div>
                </div>
                <div className="article-pdf-actions">
                  <a
                    href={pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="article-pdf-btn primary"
                  >
                    <FaExternalLinkAlt /> Ouvrir
                  </a>
                  <a
                    href={pdfUrl}
                    download={article.pdfDownloadName || true}
                    className="article-pdf-btn secondary"
                  >
                    <FaDownload /> Télécharger
                  </a>
                </div>
              </div>

              <p className="article-pdf-hint">
                Consultez le document ci-dessous — utilisez les flèches pour
                changer de page ou passez en plein écran.
              </p>

              <div className="article-pdf-viewer">
                <PdfViewer
                  url={pdfUrl}
                  ariaLabel={`Visionneuse PDF : ${article.title}`}
                />
              </div>
            </section>
          )}
        </div>

        {/* Sidebar */}
        <div className="article-sidebar">
          <h3>Autres Actualités</h3>
          <ul>
            {newsData.slice(0, 5).map((news) => (
              <li key={news.id}>
                <Link to={`/actualites/${news.id}`}>{news.title}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default NewsDetail;
